import { render, staticRenderFns } from "./form-embed.vue?vue&type=template&id=007217f9&scoped=true"
import script from "./form-embed.vue?vue&type=script&lang=js"
export * from "./form-embed.vue?vue&type=script&lang=js"
import style0 from "./form-embed.vue?vue&type=style&index=0&id=007217f9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007217f9",
  null
  
)

export default component.exports